import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

@Component({
  templateUrl: './noise-monitoring.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NoiseMonitoringPage {
  readonly windowService = inject(WindowService);
}
